var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "multi-selection-table-container no-select scroll-fire-fox"
    },
    [
      !_vm.loading &&
      _vm.fields.length > 0 &&
      _vm.availableAssets.length > 0 &&
      !_vm.editSelectedOpen
        ? _c(
            "table",
            {
              staticClass: "multi-selection-table",
              staticStyle: { position: "relative" },
              attrs: { id: "table" }
            },
            [
              _c(
                "tr",
                { staticClass: "table-header" },
                [
                  _c("th", { staticClass: "object-index" }),
                  _vm._v(" "),
                  _c("th", [_vm._v("\n        ID\n        ")]),
                  _vm._v(" "),
                  _vm._l(_vm.fields, function(field, index) {
                    return _c(
                      "th",
                      {
                        key: index + field.label,
                        staticClass: "header-cell",
                        class: { required: field.required }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(field.label) + "\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.availableAssets, function(object, objectIndex) {
                return _c(
                  "tr",
                  {
                    key: objectIndex,
                    staticClass: "table-body",
                    class: {
                      selected: _vm.selectedIndexes.includes(objectIndex)
                    }
                  },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "object-index",
                        on: {
                          click: function($event) {
                            return _vm.select(objectIndex, $event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(objectIndex + 1) + "\n      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "input-disabled",
                        on: {
                          click: function($event) {
                            return _vm.select(objectIndex, $event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(object[_vm.prefix + "_id"]) +
                            "\n      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.fields, function(field, fieldIndex) {
                      return _c(
                        "td",
                        {
                          key: fieldIndex + field.label,
                          ref: _vm.getInputRef(objectIndex, fieldIndex),
                          refInFor: true,
                          class: _vm.editionMode ? field.size : ""
                        },
                        [
                          (!_vm.editionMode ||
                            (_vm.editionMode && field.disable)) &&
                          field.input_type !== "checkbox"
                            ? _c(
                                "div",
                                {
                                  staticClass: "input-disabled with-select",
                                  on: {
                                    click: function($event) {
                                      return _vm.select(objectIndex, $event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.getNonEditableValue(object, field)
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            : _vm.isStandardInput(field.input_type)
                            ? _c("input", {
                                staticClass: "table-input",
                                class: {
                                  edited: _vm.valueWasChanged(
                                    objectIndex,
                                    field
                                  ),
                                  "required-not-filled": _vm.requiredWasMadeEmpty(
                                    objectIndex,
                                    field
                                  )
                                },
                                attrs: {
                                  type: _vm.getSpecificStandardInputType(
                                    field.input_type
                                  )
                                },
                                domProps: {
                                  value: _vm.getValue(object, field)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.setValue(
                                      objectIndex,
                                      field,
                                      $event.target.value
                                    )
                                  },
                                  keydown: [
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "up",
                                          38,
                                          $event.key,
                                          ["Up", "ArrowUp"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        -1000
                                      )
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "down",
                                          40,
                                          $event.key,
                                          ["Down", "ArrowDown"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        1000
                                      )
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "left",
                                          37,
                                          $event.key,
                                          ["Left", "ArrowLeft"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      if (
                                        "button" in $event &&
                                        $event.button !== 0
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        -1
                                      )
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "right",
                                          39,
                                          $event.key,
                                          ["Right", "ArrowRight"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      if (
                                        "button" in $event &&
                                        $event.button !== 2
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        1
                                      )
                                    }
                                  ]
                                }
                              })
                            : _vm.isSelectInput(field.input_type)
                            ? _c("treeselect", {
                                staticClass: "multi-selection-select",
                                class: {
                                  edited: _vm.valueWasChanged(
                                    objectIndex,
                                    field
                                  ),
                                  "required-not-filled": _vm.requiredWasMadeEmpty(
                                    objectIndex,
                                    field
                                  )
                                },
                                attrs: {
                                  value: _vm.getValue(object, field),
                                  options: _vm.getSpecificListOfOptions(field),
                                  clearable: _vm.selectIsClearable(field),
                                  disabled: field.multi_select_disable,
                                  disableFuzzyMatching: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setValue(
                                      objectIndex,
                                      field,
                                      $event
                                    )
                                  }
                                },
                                nativeOn: {
                                  keydown: [
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "up",
                                          38,
                                          $event.key,
                                          ["Up", "ArrowUp"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        -1000
                                      )
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "down",
                                          40,
                                          $event.key,
                                          ["Down", "ArrowDown"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        1000
                                      )
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "left",
                                          37,
                                          $event.key,
                                          ["Left", "ArrowLeft"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      if (
                                        "button" in $event &&
                                        $event.button !== 0
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        -1
                                      )
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "right",
                                          39,
                                          $event.key,
                                          ["Right", "ArrowRight"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.ctrlKey) {
                                        return null
                                      }
                                      if (
                                        "button" in $event &&
                                        $event.button !== 2
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.changePositionFocus(
                                        objectIndex,
                                        fieldIndex,
                                        1
                                      )
                                    }
                                  ]
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          field.input_type === "checkbox"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "multi-selection-checkbox-container",
                                  class: {
                                    edited: _vm.valueWasChanged(
                                      objectIndex,
                                      field
                                    )
                                  }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "multi-selection-checkbox",
                                    staticStyle: { "z-index": "100" },
                                    attrs: {
                                      "input-value": _vm.getValue(
                                        object,
                                        field
                                      ),
                                      color: "primary",
                                      ripple: false,
                                      disabled: !_vm.editionMode,
                                      "hide-details": true,
                                      disableFuzzyMatching: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.setValue(
                                          objectIndex,
                                          field,
                                          $event
                                        )
                                      }
                                    },
                                    nativeOn: {
                                      keydown: [
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "up",
                                              38,
                                              $event.key,
                                              ["Up", "ArrowUp"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (!$event.ctrlKey) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.changePositionFocus(
                                            objectIndex,
                                            fieldIndex,
                                            -1000
                                          )
                                        },
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "down",
                                              40,
                                              $event.key,
                                              ["Down", "ArrowDown"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (!$event.ctrlKey) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.changePositionFocus(
                                            objectIndex,
                                            fieldIndex,
                                            1000
                                          )
                                        },
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "left",
                                              37,
                                              $event.key,
                                              ["Left", "ArrowLeft"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (!$event.ctrlKey) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 0
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.changePositionFocus(
                                            objectIndex,
                                            fieldIndex,
                                            -1
                                          )
                                        },
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "right",
                                              39,
                                              $event.key,
                                              ["Right", "ArrowRight"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (!$event.ctrlKey) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 2
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.changePositionFocus(
                                            objectIndex,
                                            fieldIndex,
                                            1
                                          )
                                        }
                                      ]
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.fields.length > 0 && _vm.objects.length === 0
        ? _c(
            "div",
            {
              staticClass: "table-warning",
              staticStyle: {
                "font-size": "14px",
                "text-align": "center",
                "margin-top": "5%"
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("NoObjectsOfTypeInSelectedArea")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                width: "100%",
                height: "100px"
              }
            },
            [
              _c("loading-spinner", {
                attrs: {
                  active: _vm.loading,
                  "is-full-page": false,
                  color: "accent",
                  "background-color": "transparent"
                },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c4dcca8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c4dcca8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Organisms/MultipleObjectsSingleLayerTable.vue
// module id = null
// module chunks = 